export const roleRequestState = {
    current: null as null | string,
    description: null as null | string,
    ignoreRole: false,
};

export async function ignoreRoleScope<T>(fn: () => Promise<T>) {
    try {
        roleRequestState.ignoreRole = true;
        return await fn();
    } finally {
        roleRequestState.ignoreRole = false;
    }
}
